<template>
  <div
    class="Square__Pic cursor-pointer bg-white rounded-md relative"
    @click.stop.prevent="chooseImage()"
  >
    <img
      class="rounded-md pointer-events-none select-none object-cover"
      :class="{'border-2 border-bc-blue': isSelected}"
      :src="item.previewUrl"
      alt=""
      style="aspect-ratio: 1;"
      @contextmenu.prevent.stop
    />
    <aw-icon
      class="h-5 w-5 absolute bottom-1 right-1 text-white"
      icon="info"
      v-tippy="$t('Photo by %author% on Unsplash', {author: item.metadata.author})"
    />
  </div>
</template>

<script>

export default {
  mixins: [
  ],
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSelected() {
      return this.$formValues['frm-editForm-editForm-preview__url'] === this.item.fullsizeUrl
    }
  },
  methods: {
    chooseImage() {
      this.$formValues['frm-editForm-editForm-preview__url'] = this.item.fullsizeUrl
      this.$formValues['frm-editForm-editForm-preview__meta_data'] = JSON.stringify(this.item.metadata)
    },
  }
}
</script>

<style lang="scss" scoped></style>
